module.exports = __webpack_public_path__ + "img/slide-04.4128deb8.jpg";